import service from '@/services/account';
import TokenService from '@/services/TokenService';
import { remoteConfig } from '@/services/index';

class AuthService {
  constructor () {
    this.PERSISTENT_KEY = '_PERSISTENT';
  }
  async login (payload, options) {
    const params = {
      value: payload.value,
      password: payload.password,
    };
    const loginResponse = await service.login(params, payload.gcResponse, options);

    this.loginWithToken(loginResponse);

    return loginResponse;
  }

  loginWithToken (payload, isAdmin = false) {
    const oneMinInMs = 60 * 1000;
    const expireDuration = Number.parseInt(remoteConfig.getConfigValueByKey('ACCESS_TOKEN_EXPIRE_TIME', 4 * oneMinInMs));

    TokenService.setToken(payload.token, 'auth_token', isAdmin ? 24 * 60 * oneMinInMs : expireDuration);
    TokenService.setToken(payload.refreshToken, 'refresh_token');
    TokenService.setToken(JSON.stringify(payload.channels), 'supplier_channels');
  }

  logout () {
    ['auth_token', 'refresh_token', 'supplier_channels', 'seller_branch', 'productListingVersion', 'incentiveBannerHide']
      .forEach((tokenName) => TokenService.clearToken(tokenName));

    Object.keys(window.localStorage)
      .filter(key => !key.endsWith(this.PERSISTENT_KEY) && typeof window.localStorage[key] === 'string')
      .forEach(key => window.localStorage.removeItem(key));

    window.scEventBus.publish('HIDE_LIVE_CHAT_BUTTON');
  }

  isAuthenticated () {
    return TokenService.getToken();
  }
}

export default new AuthService();
